<template>
    <div
        class="caculator-container classic"
        :class="{
            nodisclosure: info.nodisclosureDes != null || hidePrice
        }"
        v-if="!info.pricePerMonth"
        @click="openCaculator('template1')"
    >
        <span class="iconfont icon-caculator">
            <span class="payment-text">{{
                $t('md-detail-info.estPayment')
            }}</span>
        </span>
        <label>
            {{
                $ft.formatCurrency({
                    value: info.nodisclosureDes != null || hidePrice
                        ? '-'
                        : pricePerMonth,
                    noSpace: true,
                    currencySymbol
                })
            }} 
        </label>
        <span>{{ $t('md-detail-info.mo') }}</span>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['openCaculator', 'showSoldPrice'],
    data: function() {
        return {};
    },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "pricePerMonth": store => store.pricePerMonth,
            "info": store => store.listingDetail.info || {}
        }),
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }
    },
    methods: {}
};
</script>
<style lang="scss">
.caculator-container.classic {
    height: 28px;
    padding: 0 10px;
    border: 1px solid #cbcbcb;
    border-radius: 2px;
    line-height: 26px;
    text-align: center;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &.nodisclosure {
        opacity: 0.4;
        cursor: initial;
        margin-bottom: 0;
        &:hover {
            background: white;
        }
        label {
            cursor: initial;
        }
    }
    label {
        cursor: pointer;
    }
    .iconfont {
        margin-right: 8px;
        color: #313b42;
    }
    .payment-text {
        font-size: 12px;
        color: var(--color-disable);
        margin-left: 5px;
    }
    @media (min-width: 601px) {
        .caculator-container:hover {
            background-color: #dee4ee;
        }
    }
    @media (max-width: 600px) {
        height: 28px;
        padding: 0 9px;
        line-height: 26px;
        font-size: 14px;
        .iconfont {
            margin-right: 5px;
        }
    }
}
</style>
